import classNames from 'classnames'
import {dataProps} from 'quickstart/theme'
import type {ComponentProps} from 'react'
import S from './styles.module.css'

export interface ShapeProps extends ComponentProps<'div'> {
  shape?: 'circle' | 'square' | 'rectangle' | 'pill'
}

export const Shape = ({shape = 'rectangle', ...props}: ShapeProps) => (
  <div
    {...dataProps({variant: shape})}
    {...props}
    className={classNames(S.shape, props.className)}
  />
)
